import React from "react";
import { CallCenterPanel, AgentCallSettings, CallHistory } from "@/components/call-center";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Phone, Settings, Users, History } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function AdminCallCenter() {
  return (
    <div className="font-['Geist',sans-serif] h-full">
      <Tabs defaultValue="calls" className="h-full flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-xl font-semibold text-white">Centre d'appels - Admin</h1>
          <TabsList className="bg-white/10">
            <TabsTrigger value="calls" className="gap-2 data-[state=active]:bg-white/20">
              <Phone className="h-4 w-4" />
              Appels
            </TabsTrigger>
            <TabsTrigger value="agents" className="gap-2 data-[state=active]:bg-white/20">
              <Users className="h-4 w-4" />
              Agents
            </TabsTrigger>
            <TabsTrigger value="history" className="gap-2 data-[state=active]:bg-white/20">
              <History className="h-4 w-4" />
              Historique
            </TabsTrigger>
            <TabsTrigger value="settings" className="gap-2 data-[state=active]:bg-white/20">
              <Settings className="h-4 w-4" />
              Paramètres
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="calls" className="flex-1 mt-0">
          <div className="bg-card rounded-lg border">
            <CallCenterPanel className="h-full" />
          </div>
        </TabsContent>

        <TabsContent value="agents" className="mt-0">
          <Card className="bg-white/10 border-white/20">
            <CardHeader>
              <CardTitle className="text-white flex items-center gap-2">
                <Users className="h-5 w-5" />
                Gestion des agents
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center py-8 text-white/60">
                <Users className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p>Liste des agents et leur disponibilité</p>
                <p className="text-sm mt-1">
                  Gérez les permissions et les horaires des agents
                </p>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="history" className="mt-0">
          <CallHistory />
        </TabsContent>

        <TabsContent value="settings" className="mt-0">
          <div className="max-w-2xl">
            <AgentCallSettings />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
